/**
 * Cart page full-screen loader with circular percentage progress.
 * Exposes window.showTjcLoader / setTjcLoaderProgress / hideTjcLoader.
 */
(function () {
    'use strict';
  
    var LOADER_ID = 'tjc-global-loader';
    var CIRCLE_R = 54;
    var CIRCUMFERENCE = 2 * Math.PI * CIRCLE_R;
  
    var depth = 0;
    var displayed = 0;
    var target = 0;
    var tickTimer = null;
    var hideTimer = null;
    var safetyTimer = null;
    var SAFETY_MS = 20000;
  
    /**
     * The cart section morph re-inserts a fresh #tjc-global-loader from the
     * server HTML. If that copy is first in the document, hide() used to clear
     * the new hidden node and leave the in-flight overlay (still at the 92%
     * creep cap) on screen. Keep one loader on document.body and drop the rest.
     */
    function primaryLoader() {
      var loaders = document.querySelectorAll('#' + LOADER_ID + ', .' + LOADER_ID);
      var primary = null;
      var i;

      for (i = 0; i < loaders.length; i++) {
        if (loaders[i].parentElement === document.body) {
          primary = loaders[i];
          break;
        }
      }

      if (!primary && loaders.length) primary = loaders[0];
      if (primary && primary.parentElement !== document.body) {
        document.body.appendChild(primary);
      }

      for (i = 0; i < loaders.length; i++) {
        if (loaders[i] !== primary) loaders[i].remove();
      }

      return primary;
    }

    function getLoader() {
      return primaryLoader();
    }
  
    function getProgressCircle(loader) {
      return loader ? loader.querySelector('.tjc-global-loader__progress') : null;
    }
  
    function getPercentEl(loader) {
      return loader ? loader.querySelector('[data-tjc-loader-percent]') : null;
    }
  
    function clampPercent(value) {
      var n = Number(value);
      if (!Number.isFinite(n)) return 0;
      return Math.min(100, Math.max(0, Math.round(n)));
    }
  
    function renderProgress(loader, percent) {
      var circle = getProgressCircle(loader);
      var label = getPercentEl(loader);
      var offset = CIRCUMFERENCE * (1 - percent / 100);
  
      if (circle) {
        circle.style.strokeDasharray = String(CIRCUMFERENCE);
        circle.style.strokeDashoffset = String(offset);
      }
      if (label) {
        label.textContent = percent + '%';
      }
      loader.setAttribute('aria-valuenow', String(percent));
    }
  
    function stopTick() {
      if (tickTimer != null) {
        clearInterval(tickTimer);
        tickTimer = null;
      }
    }
  
    function startTick() {
      stopTick();
      tickTimer = setInterval(function () {
        var loader = primaryLoader();
        if (!loader) return;

        if (displayed < target) {
          displayed = Math.min(target, displayed + 2);
        } else if (displayed < 92) {
          displayed += 1;
        }
        renderProgress(loader, displayed);
      }, 90);
    }
  
    function armSafetyTimer() {
      if (safetyTimer != null) return;
      safetyTimer = setTimeout(function () {
        safetyTimer = null;
        if (depth === 0) return;
        console.warn('[Cart] loader timed out and was cleared');
        resetTjcLoader();
      }, SAFETY_MS);
    }

    function clearSafetyTimer() {
      if (safetyTimer == null) return;
      clearTimeout(safetyTimer);
      safetyTimer = null;
    }

    function showTjcLoader(options) {
      var loader = primaryLoader();
      if (!loader) return;

      if (hideTimer != null) {
        clearTimeout(hideTimer);
        hideTimer = null;
      }

      depth += 1;
      if (depth === 1) {
        var initial = options && options.progress != null ? clampPercent(options.progress) : 8;
        displayed = initial;
        target = initial;
        loader.classList.add('active');
        loader.setAttribute('aria-hidden', 'false');
        renderProgress(loader, displayed);
        startTick();
        armSafetyTimer();
      }
    }
  
    function setTjcLoaderProgress(percent) {
      var loader = getLoader();
      if (!loader || depth === 0) return;
  
      var next = clampPercent(percent);
      target = Math.max(target, next);
      displayed = Math.max(displayed, Math.min(next, target));
      renderProgress(loader, displayed);
    }
  
    function hideTjcLoader() {
      if (depth === 0) {
        // A section morph can leave a second overlay active after the counter
        // already reached zero. Clear that leftover so it cannot sit at 92%.
        if (!document.querySelector('.' + LOADER_ID + '.active')) return;
        stopTick();
        var leftover = primaryLoader();
        if (!leftover) return;
        leftover.classList.remove('active');
        leftover.setAttribute('aria-hidden', 'true');
        return;
      }

      depth -= 1;
      if (depth > 0) return;

      clearSafetyTimer();
      stopTick();
      var loader = primaryLoader();
      if (!loader) return;

      displayed = 100;
      target = 100;
      renderProgress(loader, 100);

      hideTimer = setTimeout(function () {
        var current = primaryLoader();
        if (!current) return;
        current.classList.remove('active');
        current.setAttribute('aria-hidden', 'true');
        displayed = 0;
        target = 0;
        renderProgress(current, 0);
        hideTimer = null;
      }, 220);
    }
  
    function resetTjcLoader() {
      depth = 0;
      clearSafetyTimer();
      stopTick();
      if (hideTimer != null) {
        clearTimeout(hideTimer);
        hideTimer = null;
      }
      var loader = getLoader();
      if (!loader) return;
      loader.classList.remove('active');
      loader.setAttribute('aria-hidden', 'true');
      displayed = 0;
      target = 0;
      renderProgress(loader, 0);
    }
  
    window.showTjcLoader = showTjcLoader;
    window.setTjcLoaderProgress = setTjcLoaderProgress;
    window.hideTjcLoader = hideTjcLoader;

    document.addEventListener('cart-page:morphed', function () {
      if (depth > 0) primaryLoader();
    });

    window.addEventListener('pageshow', resetTjcLoader);
  })();